<h1 class="matp-page-title">Auditログ表示</h1>

<!-- Auditログ一覧 -->
<div class="tw-flex tw-items-center tw-min-w-[1080px]">
  <div [formGroup]="historyFormGroup" class="tw-mb-2 tw-w-[500px]">
    <div class="tw-flex tw-space-x-4 tw-items-center">
      <mat-form-field
        appearance="fill"
        class="tw-flex-1"
        (click)="startDatePicker.open()"
      >
        <mat-label>対象期間（開始）</mat-label>
        <input
          matInput
          [matDatepicker]="startDatePicker"
          placeholder="YYYY/MM/DD"
          formControlName="historyFrom"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="startDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
        <mat-error
          *ngIf="historyFormGroup.controls['historyFrom'].errors?.['required']"
        >
          対象期間（開始）を入力してください。
        </mat-error>
      </mat-form-field>
      <span class="tw-mx-2">~</span>
      <mat-form-field
        appearance="fill"
        class="tw-flex-1"
        (click)="endDatePicker.open()"
      >
        <mat-label>対象期間（終了）</mat-label>
        <input
          matInput
          [matDatepicker]="endDatePicker"
          placeholder="YYYY/MM/DD"
          formControlName="historyTo"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="endDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
        <mat-error
          *ngIf="historyFormGroup.controls['historyTo'].errors?.['required']"
        >
          対象期間（終了）を入力してください。
        </mat-error>
      </mat-form-field>

      <button
        mat-raised-button
        id="search-btn"
        class="tw-text-lg tw-mx-2"
        color="primary"
        (click)="initAuditLogList()"
        [disabled]="historyFormGroup.invalid || !checkPeriod()"
      >
        <mat-icon>search</mat-icon>
        <span>検索</span>
      </button>
    </div>
    <div class="tw-text-xs">
      @if (historyFormGroup.errors?.["dateRange"]) {
        <mat-error>開始日は終了日よりも前の日を指定してください。</mat-error>
      }
      @if (!checkPeriod()) {
        <mat-error>期間は7日以内で選択してください。</mat-error>
      }
    </div>
  </div>
  <div class="tw-flex tw-flex-row-reverse tw-ml-auto">
    <button
      mat-raised-button
      id="export-btn"
      color="primary"
      (click)="exportToCsv()"
    >
      <mat-icon>Download</mat-icon>
      エクスポート
    </button>
  </div>
</div>

<mat-card class="matp-card">
  <app-audit-log-list-table
    [auditLog]="auditLog"
    [auditLogList]="auditLogList"
    [role]="role"
    [currentTenant]="currentTenant"
    [selection]="selection"
    [operationTypeList]="operationTypeList"
  >
  </app-audit-log-list-table>
</mat-card>
